import React, { Component } from "react";
import { geolocated } from "react-geolocated";
import "./skeleton.css";
import "./normalize.css";
import "./callbackcreate.css";
import Sliders from "./sliders.js";

class Callbackcreate extends Component {
  constructor() {
    super();
    this.state = {
      gig_name: "",
      toggleSliders: false,
      danceability: 1,
      energy: 1,
      instrumentalness: 1,
      valence: 1
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.enterPressed = this.enterPressed.bind(this);
    this.handleSliderClick = this.handleSliderClick.bind(this);
    this.handleDance = this.handleDance.bind(this);
    this.handleInstrum = this.handleInstrum.bind(this);
    this.handleEnergy = this.handleEnergy.bind(this);
    this.handleValence = this.handleValence.bind(this);
  }

  get_settings() {
    return [
      this.state.danceability,
      this.state.energy,
      this.state.instrumentalness,
      this.state.valence
    ];
  }

  async handleClick() {
    if (this.state.gig_name === "") {
      alert("Please add a gig name");
    } else {
      await fetch("https://symphony-api.herokuapp.com/api/create", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          url: window.location.href,
          latitude: this.props.coords.latitude,
          longitude: this.props.coords.longitude,
          gig_name: this.state.gig_name,
          settings: this.get_settings()
        })
      })
        .then(response => response.json())
        .then(data => this.globalData(data));

      this.props.history.push("/getgig");
    }
  }

  enterPressed(event) {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.handleClick();
    }
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      [name]: value
    });
  }

  globalData(data) {
    window.id = data.id;
    window.name = data.name;
    window.uri = data.uri;
    window.gig_name = this.state.gig_name;
  }

  handleDance(event) {
    this.setState({ danceability: event.target.value });
  }

  handleEnergy(event) {
    this.setState({ energy: event.target.value });
  }

  handleInstrum(event) {
    this.setState({ instrumentalness: event.target.value });
  }

  handleValence(event) {
    this.setState({ valence: event.target.value });
  }

  handleSliderClick() {
    if (this.state.toggleSliders) {
      this.setState({
        toggleSliders: false
      });
    } else {
      this.setState({
        toggleSliders: true
      });
    }
  }

  render() {
    return (
      <div className="container">
        <div className="c-background" />
        <div className="row">
          <div className="twelve columns">
            <div className="c-title">name your gig</div>
          </div>
        </div>
        <div className="row">
          <div className="c-input">
            <div className="twelve columns">
              <input
                name="gig_name"
                type="text"
                value={this.state.gig_name}
                onChange={this.handleChange}
                onKeyPress={this.enterPressed}
                className="c-text"
                spellCheck="false"
              />
              <a className="c-submit" onClick={this.handleClick}>
                go
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="twelve columns">
            <div className="c-slider">
              <a onClick={this.handleSliderClick} className="c-toggle-button">
                Toggle settings
              </a>
              <Sliders
                toggleSliders={this.state.toggleSliders}
                onDance={this.handleDance}
                onEnergy={this.handleEnergy}
                onInstrum={this.handleInstrum}
                onValence={this.handleValence}
                danceability={this.state.danceability}
                energy={this.state.energy}
                instrumentalness={this.state.instrumentalness}
                valence={this.state.valence}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default geolocated({
  positionOptions: {
    enableHighAccuracy: true
  },
  userDecisionTimeout: 5000
})(Callbackcreate);



// WEBPACK FOOTER //
// ./src/callbackcreate.js